import { Box } from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";

type CtaSlideshowProps = {
  images: string[];
  intervalMs?: number;
};

const CtaSlideshow = ({ images, intervalMs = 4500 }: CtaSlideshowProps) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!images?.length) return;

    const id = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, intervalMs);

    return () => window.clearInterval(id);
  }, [images, intervalMs]);

  const currentSrc = images[index];

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        border: "1px solid #D8D8D8",
        borderRadius: 10,
      }}
    >
      {/* Slides */}
      <AnimatePresence mode="wait">
        <motion.img
          key={currentSrc}
          src={currentSrc}
          alt="Muzukuru Dashboard Preview"
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
          initial={{ opacity: 0, scale: 1.02 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.99 }}
          transition={{ duration: 0.8, ease: "easeInOut" }}
        />
      </AnimatePresence>

      {/* Dots */}
      <Box
        sx={{
          position: "absolute",
          bottom: 16,
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: 1.5,
          zIndex: 2,
        }}
      >
        {images.map((_, i) => {
          const isActive = i === index;

          return (
            <motion.div
              key={i}
              onClick={() => setIndex(i)}
              style={{
                width: isActive ? 22 : 10,
                height: 10,
                borderRadius: 999,
                backgroundColor: isActive
                  ? "#6b4c3b"
                  : "rgba(255, 255, 255, 0.09)",
                cursor: "pointer",
              }}
              animate={{
                width: isActive ? 22 : 10,
                backgroundColor: isActive ? "#6b4c3b" : "rgba(255,255,255,0.6)",
              }}
              transition={{ duration: 0.3 }}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default CtaSlideshow;
